import { DIRECTIONS, fmtUsd, fmtAmt } from "@/lib/api";

let ctx;
export const beep = (direction) => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = direction === "inflow" ? 440 : 880;
    g.gain.setValueAtTime(0.15, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
    o.connect(g).connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + 0.4);
  } catch (e) {
    /* audio blocked */
  }
};

export const describe = (t) => {
  const d = DIRECTIONS[t.direction] || DIRECTIONS.wallet;
  return {
    title: `${d.label}: ${fmtAmt(t.amount)} ${t.symbol} (${fmtUsd(t.amount_usd)})`,
    body: `${t.from_owner || "Unknown wallet"} → ${t.to_owner || "Unknown wallet"} · ${d.hint}`,
  };
};

export const browserNotify = (t) => {
  if (!("Notification" in window) || Notification.permission !== "granted") return;
  const { title, body } = describe(t);
  new Notification(`🐋 ${title}`, { body });
};
